import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, TemplateRef } from '@angular/core';
import { EpbtFaFilterService } from '../../services/epbt-fa-filter.service';
import { OpportunityStatus, Branch, NotepadType, PortalSearchParametersSuper } from 'ep-bt-field-agent-proxy';
import { EpButtonStyle, EpShellService, EpEventService, IEpToolTipModel, EpTextBoxComponent } from '@epicor/kinetic';
import { CustomEvents, SearchPageNames, CustomerProductPurchaseSearchDateRange } from 'ep-bt-controls';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EpbtFaCustomerService } from '../../services/epbt-fa-customer.service';
import { EpbtFaDocumentService } from '../../services/epbt-fa-document.service';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-filter-control',
  templateUrl: './epbt-fa-filter-control.component.html',
  styleUrls: ['./epbt-fa-filter-control.component.scss']
})
export class EpbtFaFilterControlComponent implements OnInit, OnDestroy, AfterViewInit {
  EpButtonStyle = EpButtonStyle;
  filterForm: FormGroup;
  dateOptions: any;
  docFilterOptions: any;
  selectedDateOption: string;
  selectedfilterOption: string;
  isDocDateRange = false;
  isProDateRange = false;
  customerCode: string;
  searchValue = '';
  pageNames = SearchPageNames;
  selectedBranchId: number;
  selectedOpportunityStatusId: number;
  selectedNotepadTypeId: number;
  selectedNotepadType: NotepadType;
  isDocDashboard = false;
  isStockTransferDateRange = false;
  isPurchaseOrderDateRange = false;
  selectedWorkOrderStatus: number;
  workOrderStatusOptions: any;
  isDateValid = true;
  submitted = false;

  // for textbox values
  opportunitySearch: string;
  notepadSearch: string;
  notepadCustomerSearch: string;
  purchasedProductSearch: string;
  purchasedJobrefSearch: string;
  docSearchValue: string;
  dashboardCustomer: string;
  stockTranfer: string;
  purchaseOrder: string;
  workOrder: string;

  @ViewChild('tooltipTemplate', { static: false }) tooltipTemplate: TemplateRef<any>;
  epToolTip: IEpToolTipModel = {
    filter: '.k-select'
  };
  constructor(private formBuilder: FormBuilder, public filterService: EpbtFaFilterService,
    private epShellService: EpShellService, private eventService: EpEventService,
    private customerService: EpbtFaCustomerService, private faDocumentService: EpbtFaDocumentService,
    private fieldAgentService: EpbtFieldAgentService) { }


  ngOnInit() {
    this.epToolTip.tooltipTemplate = this.tooltipTemplate;
    this.customerCode = this.customerService.selectedCustomer ? this.customerService.selectedCustomer.customerCode : '';
    this.isDocDashboard = this.faDocumentService.fromDashbard;
    this.filterForm = this.formBuilder.group({
      opportunitySearch: [this.filterService.pageName == SearchPageNames.DashboardOpportunitySearch ? this.filterService.dashboardOpportunitySearchValue : this.filterService.opportunitySearchValue],
      notepadSearch: [this.filterService.pageName == SearchPageNames.DashboardNotepadSearch ? this.filterService.notepadDashboardSubject : this.filterService.notepadSubject],
      notepadCustomerSearch: [this.filterService.pageName == SearchPageNames.DashboardNotepadSearch ? this.filterService.notepadDashboardCustomer : this.customerCode],
      purchasedProductSearch: [this.filterService.purchasedProductSearch],
      purchasedJobrefSearch: [this.filterService.purchasedJobrefSearch],
      dateOptionsValue: [''],
      docFilterOption: [''],
      searchValue: [''],
      docStartDate: [''],
      docEndDate: [''],
      proStartDate: [''],
      proEndDate: [''],

      dashboardCustomerSearch: [''],
      stockTransferFilterOption: [''],
      stockTransferSearchValue: [''],
      stockTransferStartDate: [''],
      stockTransferEndDate: [''],

      purchaseOrderFilterOption: [''],
      purchaseOrderSearchValue: [''],
      purchaseOrderStartDate: [''],
      purchaseOrderEndDate: [''],

      workOrderFilterOption: [''],
      workOrderSearchValue: [''],
      workOrderStatusValue: [''],
      workOrderStartDate: [''],
      workOrderEndDate: [''],
    });
    // this.opportunitySearch = this.filterService.pageName == SearchPageNames.DashboardOpportunitySearch ?
    // this.filterService.dashboardOpportunitySearchValue : this.filterService.opportunitySearchValue;
    this.LoadDropdownFields();
    this.getFilterValues();
    // this.getDates();
    // this.filterService.selectedOpportunityBranchId = this.filterService.selectedOpportunityBranchId ? this.filterService.selectedOpportunityBranchId : -1;
    // this.filterService.selectedPurchasedBranchId = this.filterService.selectedPurchasedBranchId ? this.filterService.selectedPurchasedBranchId : -1;
    // this.filterService.selectedNotepadTypeId = this.filterService.selectedNotepadTypeId ? this.filterService.selectedNotepadTypeId : 0;
    // this.filterService.selectedDateOptionId = this.filterService.selectedDateOptionId ? this.filterService.selectedDateOptionId : "AllDates";

    // this.filterForm.valueChanges.subscribe(
    //   result => {
    //     // this.saveFormValues();
    //   });
  }

  get frmFields() { return this.filterForm.controls; }

  LoadDropdownFields() {
    switch (this.filterService.pageName) {
      case SearchPageNames.CustomerNotepad:
      case SearchPageNames.DashboardNotepadSearch: {
        this.notepadDateOptions();
        break;
      }
      case SearchPageNames.CustomerOpportunity: {
        break;
      }
      case SearchPageNames.CustomerProductsPurchased: {
        this.purchasedProductDateOptions();
        break;
      }
      case SearchPageNames.CustomerOrders:
      case SearchPageNames.CustomerQuotes:
      case SearchPageNames.CustomerTempOrders:
      case SearchPageNames.CustomerCredit:
      case SearchPageNames.CustomerInvoices: {
        this.documentFilterOptions();
        break;
      }
      case SearchPageNames.DashboardStockTranferSearch: {
        this.stockTransferOptionsList();
        break;
      }
      case SearchPageNames.DashboardPurchaseOrderSearch: {
        this.purchaseOrderOptionsList();
        break;
      }
      case SearchPageNames.DashboardWorkOrderSearch: {
        this.workOrderOptionsList();
        break;
      }
      default:
        {
          break;
        }
    }
  }

  checkValidDates(startDate, endDate): boolean {
    let flag = true;
    if (!startDate || !endDate || endDate < startDate) {
      flag = false;
    }
    return flag;
  }

  // saveFormValues() {
  //   if (this.filterForm.controls['opportunitySearch']) {
  //     this.opportunitySearch = this.filterForm.controls['opportunitySearch'].value;
  //     console.log(this.opportunitySearch, "opportunitySearch")
  //   }
  //   if (this.filterForm.controls['notepadSearch']) {
  //     this.notepadSearch = this.filterForm.controls['notepadSearch'].value;
  //     console.log(this.notepadSearch, "notepadSearch")
  //   }
  //   if (this.filterForm.controls['notepadCustomerSearch']) {
  //     this.filterService.notepadCustomer = this.filterForm.controls['notepadCustomerSearch'].value;
  //   }
  //   if (this.filterForm.controls['purchasedProductSearch']) {
  //     this.filterService.purchasedProductSearch = this.filterForm.controls['purchasedProductSearch'].value;
  //   }
  //   if (this.filterForm.controls['purchasedJobrefSearch']) {
  //     this.filterService.purchasedJobrefSearch = this.filterForm.controls['purchasedJobrefSearch'].value;
  //   }
  // }

  ngAfterViewInit() {
    if (this.filterService.pageName == SearchPageNames.CustomerOpportunity) {
      this.selectedOpportunityStatusId = this.filterService.selectedOpportunityStatusId ? this.filterService.selectedOpportunityStatusId : -2;
    } else if (this.filterService.pageName == SearchPageNames.DashboardOpportunitySearch) {
      this.selectedOpportunityStatusId = this.filterService.selectedDashboardOpportunityStatusId ? this.filterService.selectedDashboardOpportunityStatusId : -2;
    }
  }

  ngOnDestroy() {
    // this.filterService.isOpportunityFilter = false;
  }

  onValueChange(selectedValue) {
    if (selectedValue instanceof Branch) {
      this.selectedBranchId = selectedValue.branchID;
    } else if (selectedValue instanceof OpportunityStatus) {
      this.selectedOpportunityStatusId = selectedValue.opportunityStatusID;
    } else if (selectedValue instanceof NotepadType) {
      this.selectedNotepadTypeId = selectedValue.notepadTypeID;
      this.selectedNotepadType = selectedValue;
    }
  }

  onDateOptionSelectionChange(selectedValue) {
    if (selectedValue) {
      this.selectedDateOption = selectedValue.dateId;
      this.updatePurchasedProductsDates(this.selectedDateOption);
    }
  }

  updatePurchasedProductsDates(selectedValue) {
    this.isProDateRange = selectedValue == 'ManualDateRange' ? true : false;
    if (this.isProDateRange) {
      const startdate = new Date(new Date().setDate(new Date().getDate() - 31));
      this.filterForm.patchValue({
        proStartDate: this.filterService.purchasedProductStartDate ? this.filterService.purchasedProductStartDate : startdate,
        proEndDate: this.filterService.purchasedProductEndDate ? this.filterService.purchasedProductEndDate : new Date(),
      });
      this.filterForm.controls['proStartDate'].setValidators([Validators.required]);
      this.filterForm.controls['proEndDate'].setValidators([Validators.required]);
    } else {
      this.filterForm.controls['proStartDate'].setValidators(null);
      this.filterForm.controls['proEndDate'].setValidators(null);
      this.filterForm.controls['proStartDate'].updateValueAndValidity();
      this.filterForm.controls['proEndDate'].updateValueAndValidity();
    }
  }
  // for docs start

  onfilterOptionSelectionChange(selectedValue) {
    if (selectedValue) {
      this.selectedfilterOption = selectedValue.value;
      this.isDocDateRange = selectedValue.name == 'Date range' ? true : false;
      switch (this.filterService.pageName) {
        case SearchPageNames.CustomerOrders: {
          if (this.faDocumentService.fromDashbard) {
            this.filterService.selectedDashboardOrdersSearchType = selectedValue.value;
            this.bindDocSelectedValues(this.filterService.ordersDashboardFilter, this.filterService.selectedDashboardOrdersSearchType);
          } else {
            this.filterService.selectedOrdersSearchType = selectedValue.value;
            this.bindDocSelectedValues(this.filterService.ordersFilter, this.filterService.selectedOrdersSearchType);
          }
          break;
        }
        case SearchPageNames.CustomerQuotes: {
          if (this.faDocumentService.fromDashbard) {
            this.filterService.selectedDashboardQuotesSearchType = selectedValue.value;
            this.bindDocSelectedValues(this.filterService.quotesDashboardFilter, this.filterService.selectedDashboardQuotesSearchType);
          } else {
            this.filterService.selectedQuotesSearchType = selectedValue.value;
            this.bindDocSelectedValues(this.filterService.quotesFilter, this.filterService.selectedQuotesSearchType);
          }
          break;
        }
        case SearchPageNames.CustomerTempOrders: {
          if (this.faDocumentService.fromDashbard) {
            this.filterService.selectedDashboardTempOrdersSearchType = selectedValue.value;
            this.bindDocSelectedValues(this.filterService.tempOrdersDashboardFilter, this.filterService.selectedDashboardTempOrdersSearchType);
          } else {
            this.filterService.selectedTempOrdersSearchType = selectedValue.value;
            this.bindDocSelectedValues(this.filterService.tempOrdersFilter, this.filterService.selectedTempOrdersSearchType);
          }
          break;
        }
        case SearchPageNames.CustomerCredit: {
          if (this.faDocumentService.fromDashbard) {
            this.filterService.selectedDashboardCreditSearchType = selectedValue.value;
            this.bindDocSelectedValues(this.filterService.creditDashboardFilter, this.filterService.selectedDashboardCreditSearchType);
          } else {
            this.filterService.selectedCreditSearchType = selectedValue.value;
            this.bindDocSelectedValues(this.filterService.creditFilter, this.filterService.selectedCreditSearchType);
          }
          break;
        }
        case SearchPageNames.CustomerInvoices: {
          if (this.faDocumentService.fromDashbard) {
            this.filterService.selectedDashboardInvoicesSearchType = selectedValue.value;
            this.bindDocSelectedValues(this.filterService.invoicesDashboardFilter, this.filterService.selectedDashboardInvoicesSearchType);
          } else {
            this.filterService.selectedInvoicesSearchType = selectedValue.value;
            this.bindDocSelectedValues(this.filterService.invoicesFilter, this.filterService.selectedInvoicesSearchType);
          }
          break;
        }
        default:
          {
            break;
          }
      }
    }
  }

  onStockTransferSelectionChange(selectedValue) {
    if (selectedValue) {
      this.selectedfilterOption = selectedValue.value;
      this.isStockTransferDateRange = this.selectedfilterOption == 'DateRequired' ? true : false;
      this.filterService.selectedDashboardstockTransfersSearchType = selectedValue.value;
      this.bindStockTransferSelectedValues(this.filterService.stockTransfersDashboardFilter, this.filterService.selectedDashboardstockTransfersSearchType);
    }
  }

  onPurchaseOrderSelectionChange(selectedValue) {
    if (selectedValue) {
      this.selectedfilterOption = selectedValue.value;
      this.isPurchaseOrderDateRange = this.selectedfilterOption == 'DateRequired' ? true : false;
      this.filterService.selectedDashboardPurchaseOrderSearchType = selectedValue.value;
      this.bindPurchaseOrderSelectedValues(this.filterService.purchaseOrderDashboardFilter, this.filterService.selectedDashboardPurchaseOrderSearchType);
    }
  }

  onWorkOrderSelectionChange(selectedValue) {
    if (selectedValue) {
      this.selectedfilterOption = selectedValue.value;
      this.filterService.selectedDashboardWorkOrderSearchType = selectedValue.value;
      this.bindWorkOrderSelectedValues(this.filterService.workOrderDashboardFilter, this.filterService.selectedDashboardWorkOrderSearchType);
    }
  }

  setDocFilterValue() {
    if (this.filterForm.controls['searchValue'] || (this.filterForm.controls['docStartDate'] && this.filterForm.controls['docEndDate'])) {
      // let searchValue = this.filterForm.controls['searchValue'] ? this.filterForm.controls['searchValue'].value : "";
      const searchValue = this.docSearchValue ? this.docSearchValue : '';
      const startDate = this.filterForm.controls['docStartDate'] ? this.filterForm.controls['docStartDate'].value : new Date();
      const endDate = this.filterForm.controls['docEndDate'] ? this.filterForm.controls['docEndDate'].value : new Date();
      // startDate = this.fieldAgentService.convertToUtc(startDate);
      // endDate = this.fieldAgentService.convertToUtc(endDate);
      // startDate.setHours(0, 0, 0, 0);
      // endDate.setHours(23, 59, 59);
      switch (this.filterService.pageName) {
        case SearchPageNames.CustomerOrders: {
          if (this.faDocumentService.fromDashbard) {
            this.searchValue = this.filterService.selectedDashboardOrdersSearchType == 'OrderNumber' ? searchValue : undefined;
            this.saveDocSelectedValues(this.filterService.ordersDashboardFilter, this.filterService.selectedDashboardOrdersSearchType, searchValue, startDate, endDate);
          } else {
            this.searchValue = this.filterService.selectedOrdersSearchType == 'OrderNumber' ? searchValue : undefined;
            this.saveDocSelectedValues(this.filterService.ordersFilter, this.filterService.selectedOrdersSearchType, searchValue, startDate, endDate);
          }
          break;
        }
        case SearchPageNames.CustomerQuotes: {
          if (this.faDocumentService.fromDashbard) {
            this.searchValue = this.filterService.selectedDashboardQuotesSearchType == 'QuoteNumber' ? searchValue : undefined;
            this.saveDocSelectedValues(this.filterService.quotesDashboardFilter, this.filterService.selectedDashboardQuotesSearchType, searchValue, startDate, endDate);
          } else {
            this.searchValue = this.filterService.selectedQuotesSearchType == 'QuoteNumber' ? searchValue : undefined;
            this.saveDocSelectedValues(this.filterService.quotesFilter, this.filterService.selectedQuotesSearchType, searchValue, startDate, endDate);
          }
          break;
        }
        case SearchPageNames.CustomerTempOrders: {
          if (this.faDocumentService.fromDashbard) {
            this.searchValue = this.filterService.selectedDashboardTempOrdersSearchType == 'OrderNumber' ? searchValue : undefined;
            this.saveDocSelectedValues(this.filterService.tempOrdersDashboardFilter, this.filterService.selectedDashboardTempOrdersSearchType, searchValue, startDate, endDate);
          } else {
            this.searchValue = this.filterService.selectedTempOrdersSearchType == 'OrderNumber' ? searchValue : undefined;
            this.saveDocSelectedValues(this.filterService.tempOrdersFilter, this.filterService.selectedTempOrdersSearchType, searchValue, startDate, endDate);
          }
          break;
        }
        case SearchPageNames.CustomerCredit: {
          if (this.faDocumentService.fromDashbard) {
            this.searchValue = this.filterService.selectedDashboardCreditSearchType == 'CreditNoteNumber' ? searchValue : undefined;
            this.saveDocSelectedValues(this.filterService.creditDashboardFilter, this.filterService.selectedDashboardCreditSearchType, searchValue, startDate, endDate);
          } else {
            this.searchValue = this.filterService.selectedCreditSearchType == 'CreditNoteNumber' ? searchValue : undefined;
            this.saveDocSelectedValues(this.filterService.creditFilter, this.filterService.selectedCreditSearchType, searchValue, startDate, endDate);
          }
          break;
        }
        case SearchPageNames.CustomerInvoices: {
          if (this.faDocumentService.fromDashbard) {
            this.searchValue = this.filterService.selectedDashboardInvoicesSearchType == 'InvoiceNumber' ? searchValue : undefined;
            this.saveDocSelectedValues(this.filterService.invoicesDashboardFilter, this.filterService.selectedDashboardInvoicesSearchType, searchValue, startDate, endDate);
          } else {
            this.searchValue = this.filterService.selectedInvoicesSearchType == 'InvoiceNumber' ? searchValue : undefined;
            this.saveDocSelectedValues(this.filterService.invoicesFilter, this.filterService.selectedInvoicesSearchType, searchValue, startDate, endDate);
          }
          break;
        }
        default:
          {
            break;
          }
      }
    }
  }

  getFilterValues() {
    switch (this.filterService.pageName) {
      case SearchPageNames.CustomerOpportunity: {
        this.opportunitySearch = this.filterService.opportunitySearchValue;
        this.selectedBranchId = this.filterService.selectedOpportunityBranchId ? this.filterService.selectedOpportunityBranchId : -1;
        this.selectedOpportunityStatusId = this.filterService.selectedOpportunityStatusId ? this.filterService.selectedOpportunityStatusId : -2;
        break;
      }
      case SearchPageNames.DashboardOpportunitySearch: {
        this.opportunitySearch = this.filterService.dashboardOpportunitySearchValue;
        this.selectedBranchId = this.filterService.selectedDashboardOpportunityBranchId ? this.filterService.selectedDashboardOpportunityBranchId : -1;
        this.selectedOpportunityStatusId = this.filterService.selectedDashboardOpportunityStatusId ? this.filterService.selectedDashboardOpportunityStatusId : -2;
        break;
      }
      case SearchPageNames.CustomerNotepad: {
        this.notepadSearch = this.filterService.notepadSubject;
        this.notepadCustomerSearch = this.filterService.notepadCustomer;
        this.selectedNotepadTypeId = this.filterService.selectedNotepadTypeId ? this.filterService.selectedNotepadTypeId : 0;
        this.selectedDateOption = this.filterService.selectedDateOptionId ? this.filterService.selectedDateOptionId : 'AllDates';
        this.filterForm.patchValue({
          dateOptionsValue: this.selectedDateOption
        });
        break;
      }
      case SearchPageNames.DashboardNotepadSearch: {
        this.notepadSearch = this.filterService.notepadDashboardSubject;
        this.notepadCustomerSearch = this.filterService.notepadDashboardCustomer;
        this.selectedNotepadTypeId = this.filterService.selectedDashboardNotepadTypeId ? this.filterService.selectedDashboardNotepadTypeId : 0;
        this.selectedDateOption = this.filterService.selectedDashboardDateOptionId ? this.filterService.selectedDashboardDateOptionId : 'AllDates';
        this.filterForm.patchValue({
          dateOptionsValue: this.selectedDateOption,
          notepadCustomerSearch: this.filterService.notepadDashboardCustomer ? this.filterService.notepadDashboardCustomer : ''
        });
        break;
      }
      case SearchPageNames.CustomerProductsPurchased: {
        this.purchasedProductSearch = this.filterService.purchasedProductSearch;
        this.purchasedJobrefSearch = this.filterService.purchasedJobrefSearch;
        this.selectedBranchId = this.filterService.selectedPurchasedBranchId ? this.filterService.selectedPurchasedBranchId : -1;
        this.selectedDateOption = this.filterService.selectedPurchasedDateOptionId ? this.filterService.selectedPurchasedDateOptionId : 'Last30Days';
        // this.isProDateRange = this.selectedDateOption == "ManualDateRange" ? true : false;
        this.filterForm.patchValue({
          dateOptionsValue: this.selectedDateOption
        });
        this.updatePurchasedProductsDates(this.selectedDateOption);
        break;
      }

      case SearchPageNames.CustomerOrders: {
        if (this.faDocumentService.fromDashbard) {
          this.bindDocSelectedValues(this.filterService.ordersDashboardFilter, this.filterService.selectedDashboardOrdersSearchType);
        } else {
          this.bindDocSelectedValues(this.filterService.ordersFilter, this.filterService.selectedOrdersSearchType);
        }
        break;
      }
      case SearchPageNames.CustomerQuotes: {
        if (this.faDocumentService.fromDashbard) {
          this.bindDocSelectedValues(this.filterService.quotesDashboardFilter, this.filterService.selectedDashboardQuotesSearchType);
        } else {
          this.bindDocSelectedValues(this.filterService.quotesFilter, this.filterService.selectedQuotesSearchType);
        }
        break;
      }
      case SearchPageNames.CustomerTempOrders: {
        if (this.faDocumentService.fromDashbard) {
          this.bindDocSelectedValues(this.filterService.tempOrdersDashboardFilter, this.filterService.selectedDashboardTempOrdersSearchType);
        } else {
          this.bindDocSelectedValues(this.filterService.tempOrdersFilter, this.filterService.selectedTempOrdersSearchType);
        }
        break;
      }
      case SearchPageNames.CustomerCredit: {
        if (this.faDocumentService.fromDashbard) {
          this.bindDocSelectedValues(this.filterService.creditDashboardFilter, this.filterService.selectedDashboardCreditSearchType);
        } else {
          this.bindDocSelectedValues(this.filterService.creditFilter, this.filterService.selectedCreditSearchType);
        }
        break;
      }
      case SearchPageNames.CustomerInvoices: {
        if (this.faDocumentService.fromDashbard) {
          this.bindDocSelectedValues(this.filterService.invoicesDashboardFilter, this.filterService.selectedDashboardInvoicesSearchType);
        } else {
          this.bindDocSelectedValues(this.filterService.invoicesFilter, this.filterService.selectedInvoicesSearchType);
        }
        break;
      }
      case SearchPageNames.CustomerStatements: {
        this.filterForm.patchValue({
          dashboardCustomerSearch: this.filterService.selectedDashboardStatementsCustomer ? this.filterService.selectedDashboardStatementsCustomer : ''
        });
        this.dashboardCustomer = this.filterService.selectedDashboardStatementsCustomer ? this.filterService.selectedDashboardStatementsCustomer : '';
        break;
      }
      case SearchPageNames.CustomerCallOffOrders: {
        this.filterForm.patchValue({
          dashboardCustomerSearch: this.filterService.selectedDashboardCalloffCustomer ? this.filterService.selectedDashboardCalloffCustomer : ''
        });
        this.dashboardCustomer = this.filterService.selectedDashboardCalloffCustomer ? this.filterService.selectedDashboardCalloffCustomer : '';
        break;
      }
      case SearchPageNames.DashboardStockTranferSearch: {
        this.bindStockTransferSelectedValues(this.filterService.stockTransfersDashboardFilter, this.filterService.selectedDashboardstockTransfersSearchType);
        break;
      }
      case SearchPageNames.DashboardPurchaseOrderSearch: {
        this.bindPurchaseOrderSelectedValues(this.filterService.purchaseOrderDashboardFilter, this.filterService.selectedDashboardPurchaseOrderSearchType);
        break;
      }
      case SearchPageNames.DashboardWorkOrderSearch: {
        this.bindWorkOrderSelectedValues(this.filterService.workOrderDashboardFilter, this.filterService.selectedDashboardWorkOrderSearchType);
        break;
      }
      default:
        {
          break;
        }
    }
  }

  bindDocSelectedValues(filters, selectedFilter) {
    const item = filters.find(i => i.propertyName == selectedFilter);
    this.filterForm.patchValue({
      searchValue: item ? item.searchValue : (selectedFilter == 'Customer' && !this.faDocumentService.fromDashbard) ? this.customerCode : '',
      docFilterOption: item ? item.propertyName : selectedFilter
    });
    this.docSearchValue = item ? item.searchValue : (selectedFilter == 'Customer' && !this.faDocumentService.fromDashbard) ? this.customerCode : '';
    this.selectedfilterOption = item ? item.propertyName : selectedFilter;
    const dateRangeText = this.docFilterOptions.find(item => item.value == this.selectedfilterOption).name;
    this.isDocDateRange = dateRangeText == 'Date range' ? true : false;
    if (this.isDocDateRange) {
      const startdate = new Date(new Date().setDate(new Date().getDate() - 31));
      this.filterForm.patchValue({
        docStartDate: item ? item.searchStartingValue : startdate,
        docEndDate: item ? item.searchEndingValue : new Date()
      });
      this.filterForm.controls['docStartDate'].setValidators([Validators.required]);
      this.filterForm.controls['docEndDate'].setValidators([Validators.required]);
    } else {
      this.filterForm.controls['docStartDate'].setValidators(null);
      this.filterForm.controls['docEndDate'].setValidators(null);
      this.filterForm.controls['docStartDate'].updateValueAndValidity();
      this.filterForm.controls['docEndDate'].updateValueAndValidity();
    }
  }

  bindStockTransferSelectedValues(filters, selectedFilter) {
    const item = filters.find(i => i.propertyName == selectedFilter);
    this.filterForm.patchValue({
      stockTransferSearchValue: item ? item.searchValue : '',
      stockTransferFilterOption: item ? item.propertyName : selectedFilter
    });
    this.stockTranfer = item ? item.searchValue : '';
    this.selectedfilterOption = item ? item.propertyName : selectedFilter;
    //  let dateRangeText = this.docFilterOptions.find(item => item.value == this.selectedfilterOption).name;
    this.isStockTransferDateRange = this.selectedfilterOption == 'DateRequired' ? true : false;
    if (this.isStockTransferDateRange) {
      const startdate = new Date(new Date().setDate(new Date().getDate() - 31));
      this.filterForm.patchValue({
        stockTransferStartDate: item ? item.searchStartingValue : startdate,
        stockTransferEndDate: item ? item.searchEndingValue : new Date()
      });
      this.filterForm.controls['stockTransferStartDate'].setValidators([Validators.required]);
      this.filterForm.controls['stockTransferEndDate'].setValidators([Validators.required]);
    } else {
      this.filterForm.controls['stockTransferStartDate'].setValidators(null);
      this.filterForm.controls['stockTransferEndDate'].setValidators(null);
      this.filterForm.controls['stockTransferStartDate'].updateValueAndValidity();
      this.filterForm.controls['stockTransferEndDate'].updateValueAndValidity();
    }
  }

  bindPurchaseOrderSelectedValues(filters, selectedFilter) {
    const item = filters.find(i => i.propertyName == selectedFilter);
    this.filterForm.patchValue({
      purchaseOrderSearchValue: item ? item.searchValue : '',
      purchaseOrderFilterOption: item ? item.propertyName : selectedFilter
    });
    this.purchaseOrder = item ? item.searchValue : '';
    this.selectedfilterOption = item ? item.propertyName : selectedFilter;
    this.isPurchaseOrderDateRange = this.selectedfilterOption == 'DateRequired' ? true : false;
    if (this.isPurchaseOrderDateRange) {
      const startdate = new Date(new Date().setDate(new Date().getDate() - 31));
      this.filterForm.patchValue({
        purchaseOrderStartDate: item ? item.searchStartingValue : startdate,
        purchaseOrderEndDate: item ? item.searchEndingValue : new Date()
      });
      this.filterForm.controls['purchaseOrderStartDate'].setValidators([Validators.required]);
      this.filterForm.controls['purchaseOrderEndDate'].setValidators([Validators.required]);
    } else {
      this.filterForm.controls['purchaseOrderStartDate'].setValidators(null);
      this.filterForm.controls['purchaseOrderEndDate'].setValidators(null);
      this.filterForm.controls['purchaseOrderStartDate'].updateValueAndValidity();
      this.filterForm.controls['purchaseOrderEndDate'].updateValueAndValidity();
    }
  }

  bindWorkOrderSelectedValues(filters, selectedFilter) {
    const item = filters.find(i => i.propertyName == selectedFilter);
    this.selectedfilterOption = item ? item.propertyName : selectedFilter;
    this.filterForm.patchValue({
      workOrderSearchValue: item ? item.searchValue : '',
      workOrderFilterOption: item ? item.propertyName : selectedFilter
    });
    this.workOrder = item ? item.searchValue : '';
    this.filterForm.controls['workOrderStartDate'].setValidators(null);
    this.filterForm.controls['workOrderEndDate'].setValidators(null);
    this.filterForm.controls['workOrderStartDate'].updateValueAndValidity();
    this.filterForm.controls['workOrderEndDate'].updateValueAndValidity();

    if (this.selectedfilterOption == 'DateRequired') {
      const startdate = new Date(new Date().setDate(new Date().getDate() - 31));
      this.filterForm.patchValue({
        workOrderStartDate: item ? item.searchStartingValue : startdate,
        workOrderEndDate: item ? item.searchEndingValue : new Date()
      });
      this.filterForm.controls['workOrderStartDate'].setValidators([Validators.required]);
      this.filterForm.controls['workOrderEndDate'].setValidators([Validators.required]);
      this.filterForm.controls['workOrderStartDate'].updateValueAndValidity();
      this.filterForm.controls['workOrderEndDate'].updateValueAndValidity();
    } else if (this.selectedfilterOption == 'Status') {
      this.workOrderStatusOptionsList();
      this.filterForm.patchValue({
        workOrderStatusValue: item ? item.searchValue : this.workOrderStatusOptions[0].value
      });
      this.selectedWorkOrderStatus = item ? item.searchValue : this.workOrderStatusOptions[0].value;
    } else if (this.selectedfilterOption == 'BranchID') {
      this.selectedBranchId = item ? parseInt(item.searchValue) : -1;
    }
  }

  saveDocSelectedValues(filters, selectedFilter, searchValue, startDate, endDate) {
    const item = filters.find(i => i.propertyName == selectedFilter);
    if (item) {
      item.searchValue = searchValue;
      if (this.isDocDateRange) {
        item.searchStartingValue = startDate;
        item.searchEndingValue = endDate;
      }
    } else {
      const parms = new PortalSearchParametersSuper();
      parms.propertyName = selectedFilter;
      parms.searchValue = searchValue;
      if (this.isDocDateRange) {
        parms.searchStartingValue = startDate;
        parms.searchEndingValue = endDate;
      }
      filters.push(parms);
    }
  }

  saveStockTransferSelectedValues() {
    // let searchValue = this.filterForm.controls['stockTransferSearchValue'] ? this.filterForm.controls['stockTransferSearchValue'].value : "";
    const searchValue = this.stockTranfer ? this.stockTranfer : '';
    const startDate = this.filterForm.controls['stockTransferStartDate'] ? this.filterForm.controls['stockTransferStartDate'].value : new Date();
    const endDate = this.filterForm.controls['stockTransferEndDate'] ? this.filterForm.controls['stockTransferEndDate'].value : new Date();
    // startDate.setHours(0, 0, 0, 0);
    // endDate.setHours(23, 59, 59);
    this.searchValue = this.filterService.selectedDashboardstockTransfersSearchType == 'OrderNumber' ? searchValue : undefined;

    const item = this.filterService.stockTransfersDashboardFilter.find(i => i.propertyName == this.filterService.selectedDashboardstockTransfersSearchType);
    if (item) {
      item.searchValue = searchValue;
      if (this.isStockTransferDateRange) {
        item.searchStartingValue = startDate;
        item.searchEndingValue = endDate;
      }
    } else {
      const parms = new PortalSearchParametersSuper();
      parms.propertyName = this.filterService.selectedDashboardstockTransfersSearchType;
      parms.searchValue = searchValue;
      if (this.isStockTransferDateRange) {
        parms.searchStartingValue = startDate;
        parms.searchEndingValue = endDate;
      }
      this.filterService.stockTransfersDashboardFilter.push(parms);
    }
  }

  saveWorkOrderSelectedValues() {
    // let searchValue = this.filterForm.controls['workOrderSearchValue'] ? this.filterForm.controls['workOrderSearchValue'].value : "";
    const searchValue = this.workOrder ? this.workOrder : '';
    const statusValue = this.filterForm.controls['workOrderStatusValue'] ? this.filterForm.controls['workOrderStatusValue'].value : '0';

    const startDate = this.filterForm.controls['workOrderStartDate'] ? this.filterForm.controls['workOrderStartDate'].value : new Date();
    const endDate = this.filterForm.controls['workOrderEndDate'] ? this.filterForm.controls['workOrderEndDate'].value : new Date();
    // startDate.setHours(0, 0, 0, 0);
    // endDate.setHours(23, 59, 59);
    this.searchValue = this.filterService.selectedDashboardWorkOrderSearchType == 'WorksOrderNumber' ? searchValue : undefined;
    const item = this.filterService.workOrderDashboardFilter.find(i => i.propertyName == this.filterService.selectedDashboardWorkOrderSearchType);
    if (item) {

      if (item.propertyName == 'DateRequired') {
        item.searchStartingValue = startDate;
        item.searchEndingValue = endDate;
      } else if (item.propertyName == 'Status') {
        item.searchValue = statusValue;
      } else if (item.propertyName == 'BranchID') {
        item.searchValue = this.selectedBranchId.toString();
      } else { item.searchValue = searchValue; }
    } else {
      const parms = new PortalSearchParametersSuper();
      parms.propertyName = this.filterService.selectedDashboardWorkOrderSearchType;
      parms.searchValue = searchValue;
      if (parms.propertyName == 'DateRequired') {
        parms.searchStartingValue = startDate;
        parms.searchEndingValue = endDate;
      } else if (parms.propertyName == 'Status') {
        parms.searchValue = statusValue;
      } else if (parms.propertyName == 'BranchID') {
        parms.searchValue = this.selectedBranchId.toString();
      } else { parms.searchValue = searchValue; }
      this.filterService.workOrderDashboardFilter.push(parms);
    }
  }

  savePurchaseOrderSelectedValues() {
    // let searchValue = this.filterForm.controls['purchaseOrderSearchValue'] ? this.filterForm.controls['purchaseOrderSearchValue'].value : "";
    const searchValue = this.purchaseOrder ? this.purchaseOrder : '';
    const startDate = this.filterForm.controls['purchaseOrderStartDate'] ? this.filterForm.controls['purchaseOrderStartDate'].value : new Date();
    const endDate = this.filterForm.controls['purchaseOrderEndDate'] ? this.filterForm.controls['purchaseOrderEndDate'].value : new Date();
    // startDate.setHours(0, 0, 0, 0);
    // endDate.setHours(23, 59, 59);
    this.searchValue = this.filterService.selectedDashboardPurchaseOrderSearchType == 'PurchaseOrderNumber' ? searchValue : undefined;

    const item = this.filterService.purchaseOrderDashboardFilter.find(i => i.propertyName == this.filterService.selectedDashboardPurchaseOrderSearchType);
    if (item) {
      item.searchValue = searchValue;
      if (this.isPurchaseOrderDateRange) {
        item.searchStartingValue = startDate;
        item.searchEndingValue = endDate;
      }
    } else {
      const parms = new PortalSearchParametersSuper();
      parms.propertyName = this.filterService.selectedDashboardPurchaseOrderSearchType;
      parms.searchValue = searchValue;
      if (this.isPurchaseOrderDateRange) {
        parms.searchStartingValue = startDate;
        parms.searchEndingValue = endDate;
      }
      this.filterService.purchaseOrderDashboardFilter.push(parms);
    }
  }

  // for docs end

  saveOpportunityValues() {
    if (this.filterService.pageName == SearchPageNames.CustomerOpportunity) {
      // this.filterService.opportunitySearchValue = this.filterForm.controls['opportunitySearch'] ? this.filterForm.controls['opportunitySearch'].value : "";
      this.filterService.opportunitySearchValue = this.opportunitySearch ? this.opportunitySearch : '';
      this.filterService.selectedOpportunityBranchId = this.selectedBranchId;
      this.filterService.selectedOpportunityStatusId = this.selectedOpportunityStatusId;
    } else if (this.filterService.pageName == SearchPageNames.DashboardOpportunitySearch) {
      // this.filterService.dashboardOpportunitySearchValue = this.filterForm.controls['opportunitySearch'] ? this.filterForm.controls['opportunitySearch'].value : "";
      this.filterService.dashboardOpportunitySearchValue = this.opportunitySearch ? this.opportunitySearch : '';
      this.filterService.selectedDashboardOpportunityBranchId = this.selectedBranchId;
      this.filterService.selectedDashboardOpportunityStatusId = this.selectedOpportunityStatusId;
    }
  }

  saveNotepadValues() {
    if (this.filterService.pageName == SearchPageNames.CustomerNotepad) {
      // this.filterService.notepadSubject = this.filterForm.controls['notepadSearch'] ? this.filterForm.controls['notepadSearch'].value : "";
      this.filterService.notepadSubject = this.notepadSearch ? this.notepadSearch : '';
      this.filterService.selectedNotepadTypeId = this.selectedNotepadTypeId;
      this.filterService.selectedNotepadType = this.selectedNotepadType;
      this.filterService.selectedDateOptionId = this.selectedDateOption;
    } else if (this.filterService.pageName == SearchPageNames.DashboardNotepadSearch) {
      // this.filterService.notepadDashboardSubject = this.filterForm.controls['notepadSearch'] ? this.filterForm.controls['notepadSearch'].value : "";
      this.filterService.notepadDashboardSubject = this.notepadSearch ? this.notepadSearch : '';
      this.filterService.selectedDashboardNotepadTypeId = this.selectedNotepadTypeId;
      this.filterService.selectedDashboardNotepadType = this.selectedNotepadType;
      this.filterService.selectedDashboardDateOptionId = this.selectedDateOption;
      // this.filterService.notepadDashboardCustomer = this.filterForm.controls['notepadCustomerSearch'] ? this.filterForm.controls['notepadCustomerSearch'].value : "";
      this.filterService.notepadDashboardCustomer = this.notepadCustomerSearch ? this.notepadCustomerSearch : '';
    }
  }

  savePurchasedProductValues() {
    if (this.filterForm.controls['purchasedProductSearch']) {
      // this.filterService.purchasedProductSearch = this.filterForm.controls['purchasedProductSearch'].value;
      this.filterService.purchasedProductSearch = this.purchasedProductSearch ? this.purchasedProductSearch : '';
    }
    if (this.filterForm.controls['purchasedJobrefSearch']) {
      // this.filterService.purchasedJobrefSearch = this.filterForm.controls['purchasedJobrefSearch'].value;
      this.filterService.purchasedJobrefSearch = this.purchasedJobrefSearch ? this.purchasedJobrefSearch : '';

    }
    if (this.isProDateRange && this.selectedDateOption == CustomerProductPurchaseSearchDateRange.Custom) {
      this.filterService.purchasedProductStartDate = this.filterForm.controls['proStartDate'].value ? this.filterForm.controls['proStartDate'].value : null;
      this.filterService.purchasedProductEndDate = this.filterForm.controls['proEndDate'].value ? this.filterForm.controls['proEndDate'].value : null;
      // if (this.filterService.purchasedProductStartDate)
      //   this.filterService.purchasedProductStartDate.setHours(0, 0, 0, 0);
      // if (this.filterService.purchasedProductEndDate)
      //   this.filterService.purchasedProductEndDate.setHours(23, 59, 59);
    }
    this.filterService.selectedPurchasedBranchId = this.selectedBranchId;
    this.filterService.selectedPurchasedDateOptionId = this.selectedDateOption;
  }

  onCancelFilter() {
    this.epShellService.collapseSlidingPanel();
  }

  onFilterSubmit() {
    this.submitted = true;
    switch (this.filterService.pageName) {
      case SearchPageNames.CustomerOpportunity:
      case SearchPageNames.DashboardOpportunitySearch: {
        this.saveOpportunityValues();
        break;
      }
      case SearchPageNames.CustomerNotepad:
      case SearchPageNames.DashboardNotepadSearch: {
        this.saveNotepadValues();
        break;
      }
      case SearchPageNames.CustomerProductsPurchased: {
        if (this.filterForm.valid) {
          this.isDateValid = this.isProDateRange ? this.checkValidDates(this.filterForm.controls['proStartDate'].value, this.filterForm.controls['proEndDate'].value) : true;
          if (this.isDateValid) {
            this.savePurchasedProductValues();
          }
        }
        break;
      }
      case SearchPageNames.CustomerOrders:
      case SearchPageNames.CustomerQuotes:
      case SearchPageNames.CustomerTempOrders:
      case SearchPageNames.CustomerCredit:
      case SearchPageNames.CustomerInvoices: {
        if (this.filterForm.valid) {
          this.isDateValid = this.isDocDateRange ? this.checkValidDates(this.filterForm.controls['docStartDate'].value, this.filterForm.controls['docEndDate'].value) : true;
          if (this.isDateValid) {
            this.setDocFilterValue();
          }
        }
        break;
      }
      case SearchPageNames.CustomerStatements: {
        // this.filterService.selectedDashboardStatementsCustomer = this.filterForm.controls['dashboardCustomerSearch'] ? this.filterForm.controls['dashboardCustomerSearch'].value : "";
        this.filterService.selectedDashboardStatementsCustomer = this.dashboardCustomer ? this.dashboardCustomer : '';
        break;
      }
      case SearchPageNames.CustomerCallOffOrders: {
        // this.filterService.selectedDashboardCalloffCustomer = this.filterForm.controls['dashboardCustomerSearch'] ? this.filterForm.controls['dashboardCustomerSearch'].value : "";
        this.filterService.selectedDashboardCalloffCustomer = this.dashboardCustomer ? this.dashboardCustomer : '';
        break;
      }
      case SearchPageNames.DashboardStockTranferSearch: {
        if (this.filterForm.valid) {
          this.isDateValid = this.isStockTransferDateRange ?
            this.checkValidDates(this.filterForm.controls['stockTransferStartDate'].value, this.filterForm.controls['stockTransferEndDate'].value) : true;
          if (this.isDateValid) {
            this.saveStockTransferSelectedValues();
          }
        }
        break;
      }
      case SearchPageNames.DashboardPurchaseOrderSearch: {
        if (this.filterForm.valid) {
          this.isDateValid = this.isPurchaseOrderDateRange ?
            this.checkValidDates(this.filterForm.controls['purchaseOrderStartDate'].value, this.filterForm.controls['purchaseOrderEndDate'].value) : true;
          if (this.isDateValid) {
            this.savePurchaseOrderSelectedValues();
          }
        }
        break;
      }
      case SearchPageNames.DashboardWorkOrderSearch: {
        if (this.filterForm.valid) {
          this.isDateValid = this.filterService.selectedDashboardWorkOrderSearchType == 'DateRequired' ?
            this.checkValidDates(this.filterForm.controls['workOrderStartDate'].value, this.filterForm.controls['workOrderEndDate'].value) : true;
          if (this.isDateValid) {
            this.saveWorkOrderSelectedValues();
          }
        }
        break;
      }
      default:
        {
          break;
        }
    }
  }

  notepadDateOptions() {
    this.dateOptions = [];
    this.dateOptions.push(this.filterService.defaultNotepadDateOption,
      {
        name: 'This month',
        dateId: 'ThisMonth'
      },
      {
        name: 'Last month',
        dateId: 'LastMonth'
      },
      {
        name: 'Last six months',
        dateId: 'LastSixMonths'
      }
    );
    // this.selectedDateOption = this.filterService.selectedDateOptionId ? this.filterService.selectedDateOptionId : this.dateOptions[0].dateId;
  }

  purchasedProductDateOptions() {
    this.dateOptions = [];
    this.dateOptions.push(this.filterService.defaultProductsPurchasedDateOption,
      {
        name: 'Current month',
        dateId: CustomerProductPurchaseSearchDateRange.CurrentMonth
      },
      {
        name: 'Last 2 months',
        dateId: CustomerProductPurchaseSearchDateRange.Last2Months
      },
      {
        name: 'Last 3 months',
        dateId: CustomerProductPurchaseSearchDateRange.Last3Months
      },
      {
        name: 'Last 6 months',
        dateId: CustomerProductPurchaseSearchDateRange.Last6Months
      },
      {
        name: 'Last 12 months',
        dateId: CustomerProductPurchaseSearchDateRange.Last12Months
      },
      {
        name: 'Manual date range',
        dateId: CustomerProductPurchaseSearchDateRange.Custom
      }
    );
    // this.selectedDateOption = this.filterService.selectedPurchasedDateOptionId ? this.filterService.selectedPurchasedDateOptionId : this.dateOptions[0].dateId;
  }

  documentFilterOptions() {
    this.docFilterOptions = [];
    const filterOptions = [
      { name: 'Quote #', value: 'QuoteNumber', type: 'Quote' },
      { name: 'Order #', value: 'OrderNumber', type: 'Order' },
      { name: 'Invoice #', value: 'InvoiceNumber', type: 'Invoice' },
      { name: 'Credit #', value: 'CreditNoteNumber', type: 'Credit' },
      { name: 'Template #', value: 'OrderNumber', type: 'Template' },

      { name: 'Date range', value: 'DateCreated', type: 'Quote' },
      { name: 'Date range', value: 'DateTimeCreated', type: 'Order' },
      { name: 'Date range', value: 'InvoiceDate', type: 'Invoice' },
      { name: 'Date range', value: 'CreditDate', type: 'Credit' },
      { name: 'Description', value: 'Description', type: 'Template' },

      { name: 'Product', value: 'Product', type: 'Common' },
      { name: 'Job ref', value: 'JobRef', type: 'Common' },
      { name: 'Customer ref', value: 'CustomerRef', type: 'CommonAll' },
      { name: 'Customer', value: 'Customer', type: 'CommonAll' },
    ];

    filterOptions.forEach(element => {
      if (this.filterService.pageName == SearchPageNames.CustomerQuotes && (element.type == 'Quote' || element.type == 'Common')) {
        this.docFilterOptions.push(element);
      } else if (this.filterService.pageName == SearchPageNames.CustomerOrders && (element.type == 'Order' || element.type == 'Common')) {
        this.docFilterOptions.push(element);
      } else if (this.filterService.pageName == SearchPageNames.CustomerInvoices && (element.type == 'Invoice' || element.type == 'Common')) {
        this.docFilterOptions.push(element);
      } else if (this.filterService.pageName == SearchPageNames.CustomerCredit && (element.type == 'Credit' || element.type == 'Common')) {
        this.docFilterOptions.push(element);
      } else if (this.filterService.pageName == SearchPageNames.CustomerTempOrders && (element.type == 'Template')) {
        this.docFilterOptions.push(element);
      } else if (element.type == 'CommonAll') {
        this.docFilterOptions.push(element);
      }
    });
    this.selectedfilterOption = this.docFilterOptions[0].value;
  }

  stockTransferOptionsList() {
    this.docFilterOptions = [];
    this.docFilterOptions.push({
      name: 'Stock Transfer #',
      value: 'OrderNumber'
    });
    this.docFilterOptions.push({
      name: 'Date required',
      value: 'DateRequired'
    });
    this.docFilterOptions.push({
      name: 'Product',
      value: 'Product'
    });
    this.selectedfilterOption = this.docFilterOptions[0].value;
  }

  purchaseOrderOptionsList() {
    this.docFilterOptions = [];
    this.docFilterOptions.push({
      name: 'PO #',
      value: 'PurchaseOrderNumber'
    });
    this.docFilterOptions.push({
      name: 'Date required',
      value: 'DateRequired'
    });
    this.docFilterOptions.push({
      name: 'Product',
      value: 'Product'
    });
    this.docFilterOptions.push({
      name: 'Supplier',
      value: 'Supplier'
    });
    this.selectedfilterOption = this.docFilterOptions[0].value;
  }

  workOrderStatusOptionsList() {
    this.workOrderStatusOptions = [];
    const workOrderStatus = [
      { name: 'Saved', value: '0' },
      { name: 'Parked', value: '1' },
      { name: 'Waiting for Source Material', value: '2' },
      { name: 'Waiting for AVOs', value: '3' },
      { name: 'Waiting for Processing', value: '4' },
      { name: 'Processed', value: '5' },
      { name: 'Part Processed', value: '6' },
      { name: 'Ship on Sales Order', value: '7' },
    ];
    workOrderStatus.forEach(element => {
      this.workOrderStatusOptions.push(element);
    });
    this.selectedWorkOrderStatus = this.workOrderStatusOptions[0].value;
  }

  workOrderOptionsList() {
    this.docFilterOptions = [];

    const workOrderOptions = [
      { name: 'Work Order #', value: 'WorksOrderNumber' },
      { name: 'Date required', value: 'DateRequired' },
      { name: 'Status', value: 'Status' },
      { name: 'Branch', value: 'BranchID' },
      { name: 'Customer', value: 'Customer' },
      { name: 'Order #', value: 'OrderNumber' }
    ];
    workOrderOptions.forEach(element => {
      this.docFilterOptions.push(element);
    });

    this.selectedfilterOption = this.docFilterOptions[0].value;
  }

  // Opportunity
  onOpportunityTextChange(event) {
    this.opportunitySearch = event ? event.target.value : '';
  }

  // Notepad
  onSubjectTextChange(event) {
    this.notepadSearch = event ? event.target.value : '';
  }
  onCustomerNoteTextChange(event) {
    this.notepadCustomerSearch = event ? event.target.value : '';
  }

  // purchased products
  onPurchasedProductTextChange(event) {
    this.purchasedProductSearch = event ? event.target.value : '';
  }
  onJobrefTextChange(event) {
    this.purchasedJobrefSearch = event ? event.target.value : '';
  }

  // document change
  onDocTextChange(event) {
    this.docSearchValue = event ? event.target.value : '';
  }

  // call off and statemants
  onDocCustomerTextChange(event) {
    this.dashboardCustomer = event ? event.target.value : '';
  }

  // stock transfer
  onStockTransferTextChange(event) {
    this.stockTranfer = event ? event.target.value : '';
  }

  // purchase order
  onPurchaseOrderTextChange(event) {
    this.purchaseOrder = event ? event.target.value : '';
  }

  // work order
  onWorkOrderTextChange(event) {
    this.workOrder = event ? event.target.value : '';
  }
}
